import { FragmentSerializer } from "./FragmentSerializer";

export class DownedFragmentSerializer extends FragmentSerializer {
    getRawFragment() {
        const rawPlay = "DN:";
        return rawPlay;
    }
}
